module.exports = __webpack_public_path__ + "poppins-v9-latin-italic.woff";